import { render, staticRenderFns } from "./active1.vue?vue&type=template&id=0d42d3f0&scoped=true&"
import script from "./active1.vue?vue&type=script&lang=js&"
export * from "./active1.vue?vue&type=script&lang=js&"
import style0 from "./active1.vue?vue&type=style&index=0&id=0d42d3f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d42d3f0",
  null
  
)

export default component.exports